// src/hooks/useStatuses.js
import { useEffect, useState, useCallback } from "react";
import { useSelector, useDispatch } from "react-redux";
import { setStatuses } from "../Redux/statusSlice";
import { fetchStatuses } from "../utils/fetcher";

const types = ["all"];

export function useStatuses() {
  const dispatch = useDispatch();
  const { statuses, isLoaded } = useSelector((state) => state.statuses);
  const [statusesLoading, setStatusesLoading] = useState(false);

  useEffect(() => {
    if (!isLoaded) {
      setStatusesLoading(true);

      fetchStatuses(["all"])
        .then((data) => {
          dispatch(setStatuses(data));
          setStatusesLoading(false);
        })
        .catch(() => setStatusesLoading(false));
    }
  }, [isLoaded, dispatch]);

  // ✅ Add this function to find status by ID and type
  const findStatus = useCallback(
    (id, type) => {
      const list = statuses?.[type];
      if (!Array.isArray(list)) return undefined;
      return list.find((item) => item.statusId == id);

    },
    [statuses]
  );




  return { statuses, statusesLoading, findStatus };
}
